import React, { useState } from 'react';
//fontAwesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//BottomSheet
import { BottomSheet } from 'react-spring-bottom-sheet';
//import 'react-spring-bottom-sheet/dist/style.css';
import 'src/asset/scss/plugin/bottomsheet/style.scss';
import 'src/asset/scss/plugin/bottomsheet/bottomsheet.scss';
//carousel
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import 'src/asset/scss/plugin/slick.scss'
//style
import styles from 'src/asset/scss/style/members.module.scss';
//comp

export default function _bsMember(props) {
    const { isOpen, data } = props;//props
    
    const [ currentIndex, setCurrentIndex ] = useState(1);
    /* =============== 슬라이더옵션 =============== */
    const SliderSettings = {
        arrows: false,
        dots: false,
        infinite: false,
        autoplay: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: false,
        beforeChange: (_, newIndex) => {
			setCurrentIndex(newIndex + 1);
		}
    }
    /* =============== 슬라이더옵션 =============== */
    /* =============== 카테고리필터 =============== */
    const categoryFiler = (type) => {
        switch(type) {
            case 1 : return '[엔진오일]';
            case 2 : return '[타이어]';
            case 3 : return '[정기점검]';
            case 4 : return '[기타]';
        }
    }
    /* =============== 카테고리필터 =============== */
    /* =============== 예약진행상황필터 =============== */
    const stateFiler = (type) => {
        switch(type) {
            case '1' : return '예약진행중';
            case '2' : return '예약완료';
            case '3' : return '입고완료';
            case '4' : return '점검완료';
            case '5' : return '이력등록완료';
            case '6' : return '수락지연취소';
            case '7' : return '미입고취소';
            case '8' : return '취소완료';
        }
    }
    /* =============== 예약진행상황필터 =============== */

    return (
        <BottomSheet open={isOpen} onDismiss={(e) => { props.onDismiss(false) }}
            className={'bottomsheetContainer'}
            snapPoints={({ maxHeight }) => maxHeight}
            header={
                <>
                <button className={'bottomsheetDissmissButton'} onClick={(e) => props.onDismiss(false)}><FontAwesomeIcon icon="fa-light fa-xmark" /></button>
                <div style={{marginBottom:'3.75rem'}} className={'bottomsheetHeaderContainer'}>
                    <h1>정비이력({currentIndex + ' / ' + data[0]?.RESULT_LIST.length})</h1>
                </div>
                </>
            }
            skipInitialTransition={false} scrollLocking={true} expandOnContentDrag={true}>
            <div className={styles.bottomsheetMemberDetailContainer}>
                <Slider {...SliderSettings}>
                    {data[0]?.RESULT_LIST.map((item, idx) =>
                        <ul key={idx}>
                            <li className={styles.profilArea}>
                                <div className={styles.imgArea}><img src={`${process.env.REACT_APP_IMAGE_URL + item.MODEL_IMG_SRC}`} alt={item.MEMBER_NAME} /></div>
                                <div><strong>{data[0].MEMBER_NAME}</strong><p>{stateFiler(item.STATE)}</p></div>
                                <span>{item.RESERV_DT}</span>
                            </li>
                            {item.BRAND_KOR_NAME !== undefined ? <li><label>차량</label><span>{item.BRAND_KOR_NAME + ' - ' + item.MODEL_KOR_NAME}</span></li> : null}
                            <li>
                                <label>카테고리</label>
                                <dl>
                                    {item?.ITEM_LIST.map((item, idx) =>
                                        <dd key={idx}>
                                            <small>{categoryFiler(item.CATEGORY)}</small>
                                            <span>{item.ITEM_NAME}</span>
                                        </dd>
                                    )}
                                </dl>
                            </li>
                            <li><pre>{item.RESULT}</pre></li>
                            {item.REMARK !== undefined ? <li><pre>{item.REMARK}</pre></li> : null}
                        </ul>
                    )}
                </Slider>
            </div>
        </BottomSheet>
    );
}